export const trialAllowedRoutes = (isExpiredTrial) => (route) => {
    if (isExpiredTrial) {
        return route.id === 'account';
      }
      return true;
}